import React, { useLayoutEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import Router from "./routes/Router";
import AppLayOut from "./common/AppLayOut";
import configureStore from "./redux/store";
import { Provider } from "react-redux";
import useHideUnimportantErrors from "./hooks/useHideUnimportantErrors";
import { initializeAnalytics } from "analytics/tracker";

const store = configureStore();

function App() {
  useHideUnimportantErrors();

  useLayoutEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      const userId = localStorage.getItem("user_id") || "guest";
      const userName = localStorage.getItem("name") || null;
      const departmentInfo = JSON.parse(localStorage.getItem("department_info") || "{}");
      const userType = localStorage.getItem("user_type");
      const department = departmentInfo?.title || userType;

      initializeAnalytics(userId, department, userName);
    }
  }, []);

  return (
    <Provider store={store}>
      <BrowserRouter>
        <AppLayOut>
          <Router />
        </AppLayOut>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
